import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
export default function NewPageDialog({ onCreate, onClose }) {
    const [title, setTitle] = useState('');
    const [slug, setSlug] = useState('');
    const [autoSlug, setAutoSlug] = useState(true);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);
    useEffect(() => {
        if (!autoSlug)
            return;
        setSlug(slugify(title));
    }, [title, autoSlug]);
    useEffect(() => {
        function onKey(e) { if (e.key === 'Escape' && !busy)
            onClose(); }
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [busy, onClose]);
    async function submit(e) {
        e.preventDefault();
        setBusy(true);
        setError(null);
        try {
            await onCreate({ slug: slug.trim(), title: title.trim() });
        }
        catch (err) {
            setError(err?.message ?? 'Create failed');
        }
        finally {
            setBusy(false);
        }
    }
    return (_jsx("div", { className: "modal-backdrop", onClick: (e) => { if (e.target === e.currentTarget && !busy)
            onClose(); }, children: _jsxs("form", { className: "modal small-modal", onSubmit: submit, children: [_jsxs("div", { className: "modal-head", children: [_jsx("div", { className: "modal-title", children: "New page" }), _jsx("button", { type: "button", className: "ghost", onClick: onClose, disabled: busy, children: "Close" })] }), _jsxs("div", { className: "modal-body padded", children: [_jsxs("label", { className: "field", children: [_jsx("span", { children: "Title" }), _jsx("input", { type: "text", autoFocus: true, value: title, onChange: (e) => setTitle(e.target.value), placeholder: "About us", required: true })] }), _jsxs("label", { className: "field", children: [_jsxs("span", { children: ["Slug \u00B7 /", slug || 'your-page'] }), _jsx("input", { type: "text", value: slug, onChange: (e) => { setAutoSlug(false); setSlug(e.target.value); }, placeholder: "about-us", required: true, pattern: "[a-z0-9][a-z0-9\\-]*" })] }), error && _jsx("div", { className: "err small", children: error })] }), _jsxs("div", { className: "modal-foot", children: [_jsx("span", { className: "muted small", children: "Lowercase letters, digits, hyphens." }), _jsxs("div", { className: "actions", children: [_jsx("button", { type: "button", className: "ghost", onClick: onClose, disabled: busy, children: "Cancel" }), _jsx("button", { type: "submit", disabled: busy || !title || !slug, children: busy ? 'Creating…' : 'Create' })] })] })] }) }));
}
function slugify(s) {
    return s.toLowerCase()
        .replace(/[^\w\s-]/g, '')
        .trim()
        .replace(/\s+/g, '-')
        .replace(/^-+|-+$/g, '')
        .replace(/-{2,}/g, '-')
        .slice(0, 60);
}
